/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LocationAdd = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        lat: {
            type: 'number',
            isRequired: true,
        },
        long: {
            type: 'number',
            isRequired: true,
        },
        nameId: {
            type: 'number',
            isRequired: true,
        },
        addressName: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
